module.exports = "li {\r\n    border-bottom : 0.5px solid rgba(255,255,255,.6);\r\n    border-radius: initial;\r\n}"